module.exports = __webpack_public_path__ + "img/full3-min.1d0cd458.png";